// extracted by mini-css-extract-plugin
export var closeButton = "SlideInMenuHeader-module--closeButton--053e8";
export var container = "SlideInMenuHeader-module--container--a871c";
export var title = "SlideInMenuHeader-module--title--9b26f";